import React, {Fragment, useState} from "react";
import OutsideContainer from "../../components/layout/OutsideContainer";
import TextInput from "../../components/forms/TextInput";
import Button from "../../components/forms/Button";
import {useParams} from "react-router";
import UserApi from "../../api/UserApi";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ROUTE_LOGIN} from "../../config/routes";

function ResetPassword() {
    const {t} = useTranslation();
    const [status, setStatus] = useState("showForm");
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    let token = useParams().token;

    let handleFormSubmit = (e) => {
        e.preventDefault();
        if (password !== password2) {
            setErrors({
                ...errors,
                password2: 'matchPassword'
            });
            return;
        }
        setLoading(true);
        UserApi.resetPassword(token, password)
            .then(response => {
                setLoading(false);
                if (response.data.success) {
                    setStatus("success");
                } else {
                    setErrors(response.data.errors);
                }
            })
    };

    return (
        <OutsideContainer>
            <div className="ResetPassword">
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">
                                    Passwort neu setzen
                                </h5>
                            </div>
                            <div className="card-body">
                                {status === "showForm" && (
                                    <Fragment>
                                        <div>
                                            Bitte gib dein gewünschtes Passwort an.
                                        </div>
                                        {errors.token && (
                                            <div className="alert alert-warning mt-3">
                                                {t(`errors.token.${errors.token}`)}
                                            </div>
                                        )}
                                        <div className="mt-5">
                                            <form onSubmit={handleFormSubmit}>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <TextInput type="password" name="password" label="Passwort"
                                                                   autoFocus value={password} error={errors.password}
                                                                   onChange={val => setPassword(val)}/>
                                                    </div>
                                                    <div className="col-6">
                                                        <TextInput type="password" name="password2"
                                                                   error={errors.password2}
                                                                   label="Passwort wiederholen" value={password2}
                                                                   onChange={val => setPassword2(val)}/>
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <Button label="Passwort setzen" loading={loading}/>
                                                </div>
                                            </form>
                                        </div>
                                    </Fragment>
                                )}
                                {status === "success" && (
                                    <div>
                                        Du hast dein Passwort erfolgreich gesetzt. Bitte logge dich jetzt ein.
                                        <div className="mt-3">
                                            <Link to={ROUTE_LOGIN}>
                                                Zum Login
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </OutsideContainer>
    );
}

export default ResetPassword;